import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Row, Col, Card, ListGroup, Button, Badge } from "react-bootstrap";
import { BsGeoAlt, BsTelephone, BsEnvelope, BsClock, BsCopy, BsArrowRight } from "react-icons/bs";

export default function ContactSection({
  company = "Thai Tax & Law",
  phone = "02-276-9968",
  email = "oaoffice@ornthai.com",
  mapSrc = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3875.731...ใส่ลิงก์ของคุณเอง..."
}) {
  const { t } = useTranslation();
  
  const address = t("footer.address").replace(/<br\s*\/?>/gi, " ");
  const hours = [
    { day: t("contact.hours.weekday"), time: "8:30-17:30" },
  ];

  const telHref = `tel:${phone.replace(/\s+/g, "")}`;
  const mailHref = `mailto:${email}`;

  return (
    <section style={{ padding: "64px 0", fontFamily: "Prompt, sans-serif", backgroundColor: "#f8f9fa" }}>
      <Container>
        <Row className="align-items-stretch g-4">
          {/* Left: Contact details */}
          <Col lg={5}>
            <Card className="h-100 shadow-sm border-0" style={{ borderRadius: 16 }}>
              <Card.Body className="p-4 p-md-5">
                <Badge bg="dark" className="mb-3 px-3 py-2" style={{ fontWeight: 600, borderRadius: "50px" }}>
                  {t("home_contact.badge")}
                </Badge>
                <h2 className="mb-3" style={{ fontWeight: 800 }}>{company}</h2>
                <p className="text-muted mb-4">
                  {t("home_contact.subtitle")}
                </p>

                <ListGroup variant="flush" className="mb-4">
                  <ListGroup.Item className="px-0 py-3 border-0 border-bottom">
                    <div className="d-flex">
                      <div className="me-3 mt-1 text-dark"><BsGeoAlt size={20} /></div>
                      <div>
                        <div className="fw-semibold text-dark">{t("home_contact.label_address")}</div>
                        <div className="text-muted small">{address}</div>
                      </div>
                    </div>
                  </ListGroup.Item>

                  <ListGroup.Item className="px-0 py-3 border-0 border-bottom">
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                      <div className="d-flex">
                        <div className="me-3 mt-1 text-dark"><BsTelephone size={20} /></div>
                        <div>
                          <div className="fw-semibold text-dark">{t("home_contact.label_phone")}</div>
                          <span className="text-muted small">{phone}</span>
                        </div>
                      </div>
                    </div>
                  </ListGroup.Item>

                  <ListGroup.Item className="px-0 py-3 border-0 border-bottom">
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                      <div className="d-flex">
                        <div className="me-3 mt-1 text-dark"><BsEnvelope size={20} /></div>
                        <div>
                          <div className="fw-semibold text-dark">{t("home_contact.label_email")}</div>
                          <a href={mailHref} className="text-decoration-none text-secondary small">{email}</a>
                        </div>
                      </div>
                    </div>
                  </ListGroup.Item>

                  <ListGroup.Item className="px-0 py-3 border-0">
                    <div className="d-flex">
                      <div className="me-3 mt-1 text-dark"><BsClock size={20} /></div>
                      <div>
                        <div className="fw-semibold text-dark">{t("home_contact.label_hours")}</div>
                        <ul className="mb-0 text-muted small" style={{ listStyle: "none", paddingLeft: 0 }}>
                          {hours.map((h, i) => (
                            <li key={i} className="d-flex justify-content-between gap-4">
                              <span>{h.day}</span>
                              <span className="fw-bold">{h.time}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </ListGroup.Item>
                </ListGroup>

                
              </Card.Body>
            </Card>
          </Col>

          {/* Right: Maps (1 row, 2 columns) */}
          <Col lg={7}>
            <Row className="g-3 h-100 align-items-center">
              <Col xs={12} md={6}>
                <Card className="shadow-sm border-0 overflow-hidden" style={{ borderRadius: 16 }}>
                  <Card.Body className="p-0" style={{ height: 300 }}>
                    <iframe
                      title="แผนที่ สำนักงานอรอนงค์การบัญชีและสอบบัญชี"
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d479.701115758021!2d100.58516144694542!3d13.794992604565127!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29d23e23da677%3A0x14a7d4d171d5a50c!2z4Liq4Liz4LiZ4Lix4LiB4LiH4Liy4LiZ4Lit4Lij4Lit4LiZ4LiH4LiE4LmM4LiB4Liy4Lij4Lia4Lix4LiN4LiK4Li14LmB4Lil4Liw4Liq4Lit4Lia4Lia4Lix4LiN4LiK4Li1!5e0!3m2!1sth!2sth!4v1758187232610!5m2!1sth!2sth"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      aria-label="แผนที่ตั้งบริษัท"
                    />
                  </Card.Body>
                </Card>
              </Col>
              <Col xs={12} md={6}>
                <Card className="shadow-sm border-0 overflow-hidden" style={{ borderRadius: 16 }}>
                  <Card.Body className="p-0" style={{ height: 300 }}>
                    <iframe
                      title="แผนที่ บริษัท ไทย แทคซ์ แอนด์ ลอว์ จำกัด"
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1937.3638322997665!2d100.58389953876502!3d13.795283901489938!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29d0067c574dd%3A0xc6ebce9fd46382c3!2z4Lia4Lij4Li04Lip4Lix4LiXIOC5hOC4l-C4oiDguYHguJfguITguIvguYwg4LmB4Lit4LiZ4LiU4LmMIOC4peC4reC4p-C5jCDguIjguLPguIHguLHguJQ!5e0!3m2!1sth!2sth!4v1780055419771!5m2!1sth!2sth"
                      allowFullScreen=""
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      aria-label="แผนที่ บริษัท ไทย แทคซ์ แอนด์ ลอว์ จำกัด"
                    />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      {/* Schema.org เพิ่มโอกาสให้ค้นหาเจอ (ปรับค่าให้ตรงจริง) */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LegalService",
          name: company,
          address: {
            "@type": "PostalAddress",
            streetAddress: address,
            addressCountry: "TH"
          },
          telephone: phone,
          email: email,
          openingHoursSpecification: hours
            .filter(h => !/ปิด/i.test(h.time))
            .map(h => ({
              "@type": "OpeningHoursSpecification",
              dayOfWeek: ["Monday","Tuesday","Wednesday","Thursday","Friday"],
              opens: "08:30",
              closes: "17:30"
            })),
        })
      }} />
    </section>
  );
}
